import typeCheck from 'common/util/typeCheck';

import { SR_API_ACTION_UTILITY_PARTNER_RENT_MANAGER_UNIT_TYPES_GET } from 'api/utilityActionTypes';

// Live fetch from Rent Manager — no state caching so the partner always sees current data.
export default async function getRentManagerUnitTypes(
  { state, utilityApiClient },
  { utilityPartnerId, onSuccess, onError },
) {
  typeCheck('utilityPartnerId::PositiveNumber', utilityPartnerId);

  return utilityApiClient.postWithState({
    action: SR_API_ACTION_UTILITY_PARTNER_RENT_MANAGER_UNIT_TYPES_GET,
    queryId: `${utilityPartnerId}`,
    state: state,
    payload: {
      utilityPartnerId,
    },
    onSuccess: onSuccess,
    onError: onError,
  });
}
